<template>
	<div class="mt-4 mb-5">
		<!-- Basic Details - Start -->
		<div class="row">
			<div class="col-12">
				<div class="mb-2">
					<span class="mr-3 align-middle col-mb heading-text">Basic Details</span> <span class="badge bg-violate">Staging</span>
				</div>
			</div>
			<div class="col-sm-12 col-md-4 mb-4">
				<span class="col-mb d-block">Domain Name</span>
				<strong class="d-block text-danger">{{ account.domain }}</strong>
			</div>
			<div class="col-12">
				<a v-if="account.siteLock && account.siteLock.status === 'Yes'" :href="'https://'+account.siteLock.username +':'+account.siteLock.password +'@'+ account.domain+'/wp-admin/'" target="_blank" class="btn btn-outline-primary btn-round btn-sm btn-primary mr-3">Open Staging WP Admin</a>
				<a v-else :href="`https://dev:dev@${account.domain}/wp-admin/`" target="_blank" class="btn btn-outline-primary btn-round btn-sm btn-primary mr-3">Open Staging WP Admin</a>
				<hr>
			</div>
		</div>
		<!-- Basic Details - End -->
		<!-- Site Details - Start -->
		<site-lock :account="account" :envType="envType" :collaboration="collaboration" :supervisor="supervisor"></site-lock>
		<!-- Site Details - End -->
		<!-- FTP Details - Start -->
		<div class="row">
			<div class="col-12">
				<div class="mb-2">
					<span class="mr-3 align-middle col-mb heading-text">FTP Details</span> <span class="badge bg-violate">Staging</span>
				</div>
			</div>
			<div class="col-sm-12 col-md-4 mb-4">
				<span class="col-mb d-block">Host</span>
				<span class="d-block">{{ account.ftp.host }} <i class="fa fa-copy btn btn-link text-primary" @click="doCopy(account.ftp.host)"></i></span>
			</div>
			<div class="col-sm-12 col-md-4 mb-4">
				<span class="col-mb d-block">Port</span>
				<span class="d-block">{{ account.ftp.port }}</span>
			</div>
			<div class="col-sm-12 col-md-4 mb-4">
				<span class="col-mb d-block">Mode</span>
				<span class="d-block">{{ account.ftp.mode }}</span>
			</div>
			<div class="col-sm-12 col-md-4 mb-4">
				<span class="col-mb d-block">PASV</span>
				<span class="d-block">{{ account.ftp.pasv }}</span>
			</div>
			<!--<div class="col-sm-12 col-md-4 mb-4">
				<span class="col-mb d-block">Username</span>
				<span class="d-block">{{ account.ftp.username }}</span>
			</div>
			<div class="col-sm-12 col-md-4 mb-4">
				<span class="col-mb d-block">Password</span>
				<span class="d-block">{{ account.ftp.password }}</span>
			</div>-->
			<div class="col-12">
				<ftp-list :account="account" :envType="envType"></ftp-list>
			</div>
			<div class="col-12">
				<hr>
			</div>
		</div>
		<!-- FTP Details - END -->
		<!-- phpMyAdmin Details - Start -->
		<div class="row">
			<div class="col-12">
				<div class="mb-2">
					<span class="mr-3 align-middle col-mb heading-text">phpMyAdmin Details</span> <span class="badge bg-violate">Staging</span>
				</div>
			</div>
			<div class="col-sm-12 col-md-4 mb-4" v-if="account.phpMyAdmin.popupUsername !== ''">
				<span class="col-mb d-block">Popup Username</span>
				<span class="d-block">{{ account.phpMyAdmin.popupUsername }}  <i class="fa fa-copy btn btn-link text-primary" @click="doCopy(account.phpMyAdmin.popupUsername)"></i></span>
			</div>
			<div class="col-sm-12 col-md-4 mb-4" v-if="account.phpMyAdmin.popupPassword !== ''">
				<span class="col-mb d-block">Popup Password</span>
				<span class="d-block">{{ account.phpMyAdmin.popupPassword }}  <i class="fa fa-copy btn btn-link text-primary" @click="doCopy(account.phpMyAdmin.popupPassword)"></i></span>
			</div>
			<div class="col-sm-12 col-md-4 mb-4">
				<span class="col-mb d-block">Login Username</span>
				<span class="d-block">{{ account.phpMyAdmin.username }}  <i class="fa fa-copy btn btn-link text-primary" @click="doCopy(account.phpMyAdmin.username)"></i></span>
			</div>
			<div class="col-sm-12 col-md-4 mb-2">
				<span class="col-mb d-block">Login Password</span>
				<span class="d-block">{{ account.phpMyAdmin.password }}  <i class="fa fa-copy btn btn-link text-primary" @click="doCopy(account.phpMyAdmin.password)"></i></span>
			</div>
			<div class="col-12" v-if="account.phpMyAdmin.url !== ''">
				<a :href="account.phpMyAdmin.url" target="_blank" class="btn btn-outline-primary btn-round btn-sm btn-primary">Open phpMyAdmin Portal</a>
			</div>
			<div class="col-12">
				<hr>
			</div>
		</div>
		<!-- phpMyAdmin details - end -->
		<!-- Disk Details - Start -->
		<div class="row" v-if="account.diskSpace !== undefined && account.diskSpace.length > 0">
			<div class="col-12">
				<div class="mb-2">
					<span class="mr-3 align-middle col-mb heading-text">Disk space</span><span class="badge bg-violate">Staging</span>
				</div>
			</div>
			<div class="col-sm-12">
				<div class="col-mb d-block" v-for="(item, index) in account.diskSpace" :key="item.title">
					<hr v-if="index == 2">
					{{item.name}}: <strong>{{item.size}}{{item.value}}</strong>
				</div>
			</div>
		</div>
		<!-- Disk Details - End -->
	</div>
</template>

<script>
import copyButtonMixin from "../../../../mixins/copyButtonMixin";
import SiteLock from './SiteLock'

export default {
	name: "StagingDetails",
	mixins: [copyButtonMixin],
	props: {
		account: {
			type: Object,
			required: true
		},
		envType: {
			type: String,
			required: true
		},
		collaboration: {
			type: Boolean,
			required: false
		},
		supervisor: {
			type: Object,
			required: false,
			default() {return {};}
		}
	},
	computed: {
		userToken() {
			return this.$store.getters.getUserToken;
		},
		accounts() {
			return this.$store.getters["hosting/accounts"];
		}
	},
	components: {
		SiteLock,
		FtpList: () =>
			import(/* webpackChunkName: "FtpList" */ "./Ftp/FtpList"),
	}

}
</script>

